var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { MAX_DOWNLOAD_RATE } from '@lucidlink/sdk';
import { translate, useToastService } from '@lucidlink/uicore';
import { convertRateLimitToBytesPerSecond } from '#services';
import { parseRateLimitData } from '../../../../services/RateLimit';
import { useGlobalRateLimitMutations } from '../../hooks';
export const useGlobalDownloadRateLimit = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { addToast } = useToastService();
    const { defaultNumberValue, defaultUnitValue, initialNumberValue, initialUnitValue, isDefault, isDefaultUnlimited, isUnlimited, } = parseRateLimitData(data);
    const onError = useCallback(() => {
        addToast({
            kind: 'negative',
            content: {
                message: translate("Default value wasn't updated"),
            },
            'data-testid': 'filespace-global-download-error',
        });
    }, [addToast]);
    const { isSuccess, setRateLimit, unsetRateLimit } = useGlobalRateLimitMutations({
        filespaceId,
        workspaceId,
        settingName: MAX_DOWNLOAD_RATE,
        onError,
    });
    const handleSave = useCallback((numberValue, unitValue) => {
        const bytesPerSecond = convertRateLimitToBytesPerSecond(numberValue, unitValue);
        setRateLimit(bytesPerSecond);
    }, [setRateLimit]);
    const label = translate('Download rate limit');
    const labelDefault = isDefault ? translate('Default') : undefined;
    const labelTooltip = [
        translate('Controls the maximum transfer rate when retrieving data from the cloud storage. The default speed is unlimited.'),
    ];
    const resetToDefaultTooltip = isDefaultUnlimited
        ? translate('The default value is: Unlimited')
        : translate('The default value is: {{defaultNumberValue}} {{defaultUnitValue}}', {
            defaultUnitValue,
            defaultNumberValue,
        });
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset: unsetRateLimit,
            tooltip: resetToDefaultTooltip,
        };
    const inlineFormValue = isUnlimited
        ? translate('Unlimited')
        : `${initialNumberValue} ${initialUnitValue}`;
    const scope = 'global';
    const type = 'download';
    return {
        initialNumberValue,
        initialUnitValue,
        isUnlimited,
        inlineFormValue,
        label,
        labelDefault,
        labelTooltip,
        isSuccess,
        handleSave,
        resetToDefault,
        scope,
        type,
    };
};
_react_refresh_temp_1(useGlobalDownloadRateLimit, "38kbUhE4lcsPQ3+AqE0Wh9TDBr0=", false, () => [useToastService, useGlobalRateLimitMutations]);
